import { useEffect } from 'react';

// Calls onDismiss when Escape is pressed while `active` is true. Pairs with
// useFocusTrap (which only cycles Tab) to make a dialog/drawer/slideout fully
// keyboard-dismissable — closing that a11y gap. Used by the CI rate/competitor
// detail drawers and the EI playbook detail/gallery slideouts.
//
// Listener is on window so it fires regardless of focus (the drawer's close
// button isn't always focused when the user hits Escape). onDismiss is read
// fresh each render via the dep, matching the hand-rolled handlers it replaces.
export default function useDismissable(active, onDismiss) {
  useEffect(() => {
    if (!active) return undefined;
    const onKeyDown = (e) => { if (e.key === 'Escape') onDismiss(); };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [active, onDismiss]);
}
